import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listBoxFilter'
})
export class ListBoxFilterPipe implements PipeTransform {
  transform(items: Array<any>, searchString: string, itemName: string) {
    if (items) {
      return items.filter((item) => {
        let valid = true;

        if (
          (searchString) &&
          (!item[itemName].toLowerCase().startsWith(searchString.toLowerCase()))
        ) {
          valid = false;
        }

        return valid;
      });
    }

    return items;
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/list-box/list-box-filter.pipe.ts